const getBaseRequestUrl = (name, customUrl) => {
    return customUrl || `${name.toLowerCase()}/filter-request`
}

export default getBaseRequestUrl
